import axios from "axios";
import * as actionType from "../../../constant/actionType";

export const ProviderFavouriteReportsOrNot = (apidata) => async (dispatch) => {
  /*** API Call Action ***/
  try {
    const response = await axios({
      method: "post",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/HandleFavouriteReports`,
      data: apidata,  
    });

    return response.data; 
  } catch (error) {
    console.error("Error in ProviderFavouriteReportsOrNot:", error);
    return { error: error.message }; 
  }
};


export const ProviderGetAllfavouriteReports = (apidata) => async (dispatch) => {
  /*** API Call Action ***/
  try {
    const response = await axios({
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("conserve_authtoken")}`,
      },
      url: `${actionType.environment_url}/api/admin/provider/GetAllfavouriteReports`,
      params: apidata, // Correctly passing query parameters for GET requests
    });

    // Optionally, dispatch the response to Redux store
    // dispatch({ type: actionType.SET_FAVOURITE_REPORTS, payload: response.data });

    return response.data;  // Returning the response data
  } catch (error) {
    console.error("Error in Provider GetAllfavouriteReports:", error);  // Log the error
    return { error: error.message };  // Return the error message for handling in the calling function
  }
};
